import { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCountry } from 'entities/country';
import { useDebounceFunction } from 'shared/lib/debounce';
import { SearchInput } from 'shared/ui/SearchInput';

const CountrySearchInput = (): ReactElement => {
  const { t } = useTranslation();
  const { setSearchName, searchName } = useCountry();

  const [localSearch, setLocalSearch] = useState(searchName);

  const debouncedSearchHandler = useDebounceFunction(setSearchName, 500);

  useEffect(() => {
    if (searchName === '') setLocalSearch(searchName);
  }, [searchName]);

  return (
    <SearchInput
      value={localSearch}
      onChange={(e) => {
        setLocalSearch(e.currentTarget.value);
        debouncedSearchHandler(e.currentTarget.value);
      }}
      placeholder={t('Country:SearchInput.placeholder')}
      allowClear
      onReset={() => setSearchName('')}
    />
  );
};

export { CountrySearchInput };
